import { render } from "./MemberForm.vue?vue&type=template&id=2830f902&scoped=true"
import script from "./MemberForm.vue?vue&type=script&lang=js"
export * from "./MemberForm.vue?vue&type=script&lang=js"

import "./MemberForm.vue?vue&type=style&index=0&id=2830f902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2830f902"]])

export default __exports__